import { getConfig } from "../../../../config/app";

const PRE_INSPECTION_HEADERS = {
  accept: "application/vnd.api+json",
  "Content-Type": "application/vnd.api+json",
  provider: "compara",
  authorization:
    "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwcm92aWRlciI6ImNvbXBhcmEiLCJ1dWl" +
    "kIjoiMjI1ZGZjMGMtZjYxZC00ODU0LWJlNDYtNWU3NWU0YzNhZTk1IiwiaWF0IjoxNjU0MjY4MzgwfQ" +
    ".8Dbo77ZIZELIDqqYK2IC0768YhMkJL0yOxZijEyqUQE"
};

export const getPreInspection = async (
  countryCode: string,
  plate: string
): Promise<Record<string, string>> => {
  const preInspectionURL = getConfig("preInspection.cl");

  const response = await fetch(`${preInspectionURL}/${countryCode}/${plate}/inspection`, {
    headers: PRE_INSPECTION_HEADERS
  });

  if (!response.ok) throw new Error("Plate not found");
  const jsonResponse = await response.json();
  return jsonResponse;
};
